import { SET_PRODUCTS } from 'actions/types'

const initial = []

export default (state = initial, action) => {
  switch(action.type) {
    case SET_PRODUCTS:
      return [...action.products]
    default:
      return state
  }
}
